import { render } from "./PlanExpired.vue?vue&type=template&id=79b1ad5e&scoped=true"
import script from "./PlanExpired.vue?vue&type=script&lang=js"
export * from "./PlanExpired.vue?vue&type=script&lang=js"

import "./PlanExpired.vue?vue&type=style&index=0&id=79b1ad5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b1ad5e"]])

export default __exports__